module.exports = __webpack_public_path__ + "img/IMAGE 3.57ed9b59.png";